<template>
    <v-card class="rounded-xl card-title-footer-color mx-0 px-0">
        <v-card-title class="px-5 pb-0">
            <v-row>
                <v-col cols="4">
                    <v-text-field
                        v-model="search"
                        placeholder="Buscar"
                        color="primary"
                        class="app-text-field-no-border rounded-lg ma-0 pb-3 pt-0 buscador-input"
                        hide-details="auto"
                        height="36px"
                        @input="updateDashboardData"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                    />
                </v-col>
                <v-col cols="3">
                    <app-select
                        v-model="field_selected"
                        hide-details
                        return-object
                        label="Campo"
                        item-text="date_name"
                        item-value="id"
                        :items="fields"
                        @change="updateDashboardData"
                    />
                </v-col>
                <v-col cols="5" class="d-flex justify-end">
                    <hide-deleted-switch v-model="hideDeleted" />
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text  class="px-0 pt-0 card-title-footer-color">
            <v-data-table
                :items="items"
                :headers="headers"
                :footer-props="{
                  'items-per-page-options': [5, 10, 100, 1000],
                  'items-per-page-text': 'Empresas por página:',
                }"
            >
                <template #body="{ items, headers }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td 
                                v-for="header in headers" 
                                :key="header.value"
                                class="td__selectable"
                                :style="{opacity:item.del?'0.5':'1'}"
                                @click="emitState(item.id, header.value)"
                            >
                                {{item[header.value]}}
                            </td>
                        </tr>
                        <tr class="deep-purple lighten-5 font-weight-bold">
                            <td v-for="header in headers" :key="header.value">
                                {{total[header.value]}}
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>     
</template>

<script>
import AppSelect from './layout/AppSelect.vue';
import HideDeletedSwitch from './HideDeletedSwitch.vue';
export default {
    components: {
        AppSelect,
        HideDeletedSwitch,
    },
    props: {
        states: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        dashboardData: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        initialHideDeleted: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            search: '',
            hideDeleted: this.initialHideDeleted,
            fields: [
                {id: 0, date_name: "Todos los campos"},
                {id: 1, date_name: "Todos"},
                {id: 2, date_name: "Contabilizados"},
                {id: 3, date_name: "Errores"},
                {id: 4, date_name: "Borrados"},
                {id: 5, date_name: "En proceso"},
                {id: 6, date_name: "Borr. Cont"},
                {id: 7, date_name: "Pdte. Sinc."},
                {id: 8, date_name: "Pdte. revisión"},
                {id: 9, date_name: "Contabilizando"},
                {id: 10, date_name: "Error Cont."}
            ],
            field_selected: {id: 0, date_name: "Todos los campos"}
        }
    },

    computed:{
        headers() {
            const headers = [
                {
                    text: 'Nombre',
                    value: 'name'
                }
            ]

            Object.keys(this.states).forEach(key => {
                const newHeaderObj = {}
                newHeaderObj.text = this.states[key].name
                newHeaderObj.value = key
                headers.push(newHeaderObj)
            })

            return headers
        },

        items() {
            const items = []
            this.dashboardData.forEach(elm => {
                if (elm.name === 'Total') {
                    return
                }
                const newRow = this.createRow(elm)
                items.push(newRow)
            })

            return items
        },

        total() {
            const total = this.dashboardData.filter(e => e.name === 'Total')
            return this.createRow(total[0])
        },
    },

    watch: {
        hideDeleted() {
            this.sendHideDeletedChange();
        },
    },

    methods: {
        updateDashboardData() {
            this.dashboardData.data = this.items_dashboard_data; 
            this.sendSearchChange();
            this.sendFieldChange();
        },
        sendSearchChange() {
            this.$emit('update-search-change', this.search);
        },
        sendFieldChange(){
            this.$emit("update-field-selected", this.field_selected.date_name)
        },
        sendHideDeletedChange(){
            this.$emit("update-hide-deleted", this.hideDeleted)
        },
        
        emitState(id, state) {
            if (state !== 'name') {
                this.$emit('click-dashboard-state', {id, state})
            }
        },

        createRow(elm) {
            const newRow = {
                name: elm.name,
                id: elm.id,
                del:elm.del
            }

            Object.keys(elm.states).forEach(e => {
                newRow[e] = elm.states[e]
            })

            return newRow
        },
    }
};
</script>

<style scoped>
    .row-head {
        overflow: hidden;
        position: relative;
        height: 100%;
    }
    .buttom-border {
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-name {
        border-left-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }

    .card-title-footer-color {
        background: #FAFAFF;
    }
    ::v-deep .v-data-footer {
        background-color: #FAFAFF;
        margin-right: 0px !important;
        padding-right:  17px;
    }
    ::v-deep .v-data-table-header > tr > th{
        background-color: var(--v-primaryLight-base) !important;
    }
    ::v-deep .v-data-table-header > tr > th > span{
        color: var(--v-primary-base);
        font-size: 0.875rem;
    }
    .font-color {
        color: #56565B;
    }

    ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
        border-bottom: none !important;
    }

    ::v-deep tbody tr:nth-of-type(even) {
        /* 'deep-orange lighten-5' basides on material design color */
        background-color: rgba(245, 245, 245, 0.47);
    }

    ::v-deep .v-input__prepend-inner > div > i {
        color: var(--v-primary-base);
        top: 2px;
        padding-left: 5px;
    }

    .buscador-input {
        font-weight: normal;
        font-size: 0.875rem;
    }

    .td__selectable {
        cursor: pointer;
    }

    .td__selectable:hover {
        background-color: rgba(102, 51, 153, 0.1);
    }
    .align-right{
        display: flex;
        justify-content: right;
    }
</style>